import { render, staticRenderFns } from "./CalendarSwitchButton.vue?vue&type=template&id=444ae545&scoped=true"
import script from "./CalendarSwitchButton.vue?vue&type=script&lang=js"
export * from "./CalendarSwitchButton.vue?vue&type=script&lang=js"
import style0 from "./CalendarSwitchButton.vue?vue&type=style&index=0&id=444ae545&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "444ae545",
  null
  
)

export default component.exports